const schema = [
        ['description'],
        ['startDatetime'],
        ['endDatetime'],
        ['break'],
        ['declarableTime'],
        ['addendum'],
        ['declarable'],
        ['status'],
        ['category'],
        ['project'],
        ['user'],
        ['tenant'],
        ['createdAt'],
        ['updatedAt'],
];

export default schema;
